import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { DateFormat } from '@as-react/common-types';
import { Text } from '@yonderland/andes-react';
import { Box } from '@as/cotopaxi';
const AuthorDataContainer = ({ author, dateModified, dateCreated }) => {
    const { t } = useTranslation(I18N_NAMESPACES.seo);
    const dateLastModified = dateModified !== dateCreated ? dayjs(dateModified).format(DateFormat.DD_MM_YYYY_DASH) : null;
    if (!author)
        return;
    return (_jsx(Box, { mobile: { spacing: { marginLeft: 2, marginTop: 2, marginBottom: 2 } }, children: _jsxs(Text, { variant: "bodyS", color: "tertiary", as: "span", children: [t('author.data.by'), " ", author, dateLastModified && ` • ${t('author.data.update')} ${dateLastModified}`] }) }));
};
export default AuthorDataContainer;
